module.exports = __webpack_public_path__ + "fonts/IBMPlexSans-Bold.1759ad8a.woff2";